import type { ComponentProps } from 'react';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { Box } from '@cbhq/cds-web/layout';

export type ProductIconName = ComponentProps<typeof Icon>['name'];

export type ProductIconProps = {
  name: ProductIconName;
  background: string;
  testID?: string;
};

export function ProductIcon({ name, background, testID }: ProductIconProps) {
  return (
    <Box dangerouslySetBackground={background} borderRadius={200} padding={1}>
      <Icon name={name} size="s" color="fg" testID={testID} />
    </Box>
  );
}
